import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to the top of the page on every route change.
 * Handles both native window scroll and Lenis (used on the home page)
 * by walking any elements with the [data-lenis-scroll] hook and by calling
 * lenis.scrollTo(0) on the global lenis instance if present.
 */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Native window scroll
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }
    // Reset document scrolling containers
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    // Lenis (Home page uses ReactLenis on root)
    const lenis = window.__lenis;
    if (lenis?.scrollTo) {
      try {
        lenis.scrollTo(0, { immediate: true, force: true });
      } catch {
        /* ignore */
      }
    }
  }, [pathname, search]);

  return null;
}
